import axiosInstance from './axiosInstance';

// Incentive Claim system — claims (per-sale beneficiary rows) + monthly slips.
// All endpoints live under /api/IncentiveClaim and require [Authorize].

export const getAllClaims = (params = {}) => {
    const qs = new URLSearchParams();
    if (params.campaignId != null && params.campaignId !== '') qs.append('campaignId', params.campaignId);
    if (params.agentId != null && params.agentId !== '') qs.append('agentId', params.agentId);
    if (params.status != null && params.status !== '') qs.append('status', params.status);
    const q = qs.toString();
    return axiosInstance.get(`/IncentiveClaim/GetAll${q ? `?${q}` : ''}`);
};

export const getMyClaims = () =>
    axiosInstance.get('/IncentiveClaim/GetMine');

// Super Admin only — backfills/refreshes incentive claims for every active, non-archived
// sale with a deposit date. Idempotent: never duplicates, never downgrades Paid/Slipped rows.
export const regenerateAllClaims = () =>
    axiosInstance.post('/IncentiveClaim/RegenerateAll');

export const generateMonthlySlips = (campaignId) =>
    axiosInstance.post(`/IncentiveClaim/GenerateMonthlySlips?campaignId=${campaignId}`);

export const markSlipPaid = ({ slipId, paidAmount, remarks }) =>
    axiosInstance.post('/IncentiveClaim/MarkSlipPaid', { slipId, paidAmount, remarks });

export const markSlipFulfilled = ({ slipId, remarks }) =>
    axiosInstance.post('/IncentiveClaim/MarkSlipFulfilled', { slipId, remarks });

export const getIncentiveSlips = (campaignId) => {
    const q = (campaignId != null && campaignId !== '') ? `?campaignId=${campaignId}` : '';
    return axiosInstance.get(`/IncentiveClaim/GetIncentiveSlips${q}`);
};

export const recordAsternReceipt = ({ claimId, amount, receivedOn, remark }) =>
    axiosInstance.post('/IncentiveClaim/RecordAsternReceipt', { claimId, amount, receivedOn, remark });

// Bulk: mark many Total-Incentive rows Received from Astern with one date (amount per row).
export const recordAsternReceiptBulk = ({ claimIds, receivedOn, remark }) =>
    axiosInstance.post('/IncentiveClaim/RecordAsternReceiptBulk', { claimIds, receivedOn, remark });

export const recordAgentPayout = ({ claimId, paidOn, remark }) =>
    axiosInstance.post('/IncentiveClaim/RecordAgentPayout', { claimId, paidOn, remark });

export const setClaimVoid = ({ claimId, voided }) =>
    axiosInstance.post('/IncentiveClaim/SetClaimVoid', { claimId, voided });
